import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppRouter } from './AppRouter.jsx'
import './index.css'
import './firebase/config'
import { ToastProvider } from './components/Toast'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ToastProvider>
      <AppRouter />
    </ToastProvider>
  </React.StrictMode>,
)
